import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  Divider,
  Typography
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { EnvChip, CloseableDialogTitle, ConnectionChip } from 'components/layout';
import { getWithToken } from 'api/network';
import AboutDialogDocumentation from 'components/about/AboutDialogDocumentation';
import { compose } from 'redux';
import { connect } from "react-redux";
import ProfileDialog from 'components/profile/ProfileDialog';

const styles = theme => ({ 
  content: {
    paddingTop: 16
  },
});

const AboutDialog = ({ classes, onClose, ...props }) => {

  const [profileOpen, setProfileOpen] = useState(false);
  const handleProfileClick = () => {
    setProfileOpen(true);
  };

  async function handleAlert() {
    try {
      const response = await getWithToken(`/api/ping/version`);
      const data = await response.text();
      alert(`Client version: ${process.env.REACT_APP_BUILD_NUMBER}, Server version: ${data}`);
    }
    catch (error) {
      console.log(error)
    }
  }
  return (
    <Dialog onClose={onClose} {...props} fullScreen={props.isMobile}>
      <CloseableDialogTitle id="about-dialog-title" onClose={onClose}>
        <Typography variant='h6' style={{ marginRight: 8 }}>ReVUe</Typography>
        <EnvChip />
        <ConnectionChip />
      </CloseableDialogTitle>
      <Divider />
      <DialogContent className={classes.content}>
        <DialogContentText onClick={handleAlert}>
          Version: <strong>{process.env.REACT_APP_BUILD_NUMBER}</strong>        
        </DialogContentText>
        <>
          <Typography variant='h6' style={{ fontSize: '1rem' }} display="block" gutterBottom>
            User:
          </Typography> 
          {
            props.user && 
            <Button color="primary" onClick={handleProfileClick}>{props.user ? props.user.fullName || props.user.name : ''}</Button> 
          } 
          <Typography display="block" gutterBottom>
            &nbsp;
          </Typography> 
        </>        
        <AboutDialogDocumentation />
        <ProfileDialog open={profileOpen} onClose={() => setProfileOpen(false)} user={props.user} />
      </DialogContent>
    </Dialog>
  );
};

const mapState = (state) => {
  return {
    isMobile: state?.appState?.isMobile,
  };
}

export default compose(withStyles(styles), connect(mapState))(AboutDialog);
